/**
 * 角色管理
 */

import BaseAuthClient from './baseAuth';

class RoleClient extends BaseAuthClient {
  constructor() {
    super({
      baseURL: '/api'
    });
  }
}

const roleClient = new RoleClient();

export default roleClient;

// 角色列表
export const getRoleList = (option: any) => roleClient.get(`/v1/role/getgrouprole`, option);

// 角色组列表
export const getRoleGroupList = (option: any) => roleClient.get(`/v1/role/getrolegrouplist`, option);

// 更新角色
export const updateRole = (option: any) => roleClient.put(`/v1/role/roleauth`, option);

// 角色详情
export const getRoleDetail = (option: any) => roleClient.get(`/v1/role/getroleauth`, option);
